import React from 'react';
import { ArrowDown } from 'lucide-react';

const HowItWorksSection = ({ steps }) => {
  return (
    <section style={{ background: 'var(--bg-page)', padding: '120px 0' }}>
      <div className="container">
        <div style={{ marginBottom: '80px', textAlign: 'center' }}>
          <h2 className="heading-2" style={{ color: 'var(--text-primary)', marginBottom: '24px' }}>
            HOW IT WORKS
          </h2>
          <p className="body-medium" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Simple, clear, and designed to give you clarity in under 15 minutes.
          </p>
        </div>

        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          {steps.map((step, index) => (
            <div key={step.step} style={{ marginBottom: index < steps.length - 1 ? '60px' : '0' }}>
              <div
                style={{
                  background: 'var(--bg-card)',
                  padding: '48px',
                  border: '2px solid var(--border-medium)',
                  borderRadius: '8px',
                  position: 'relative',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '32px' }}>
                  {/* Step Number */}
                  <div
                    style={{
                      width: '80px',
                      height: '80px',
                      background: 'var(--brand-primary)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <span
                      style={{
                        fontSize: '2rem',
                        fontWeight: '900',
                        color: 'var(--text-inverse)',
                        fontFamily: "'PP Right Grotesk', Arial, sans-serif",
                      }}
                    >
                      {step.step}
                    </span>
                  </div>

                  {/* Content */}
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                      <h3
                        className="heading-4"
                        style={{
                          color: 'var(--text-primary)',
                        }}
                      >
                        {step.title}
                      </h3>
                      <span
                        className="caption"
                        style={{
                          color: 'var(--brand-primary)',
                          whiteSpace: 'nowrap',
                          marginLeft: '16px',
                        }}
                      >
                        {step.duration}
                      </span>
                    </div>
                    <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>

              {/* Arrow between steps */}
              {index < steps.length - 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 0' }}>
                  <ArrowDown size={32} color="var(--brand-primary)" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
